import { datadogRum } from '@datadog/browser-rum';

export const configureDatadog = () => {
  if (
    process.env.REACT_APP_DATADOG_CLIENT_TOKEN ||
    process.env.REACT_APP_DATADOG_APPLICATION_ID
  ) {
    // Initialize Datadog
    datadogRum.init({
      applicationId: process.env.REACT_APP_DATADOG_APPLICATION_ID || '',
      clientToken: process.env.REACT_APP_DATADOG_CLIENT_TOKEN || '',
      site: 'datadoghq.com',
      service: 'act-dashboard',
      env: process.env.REACT_APP_NODE_ENV || 'development',
      sessionSampleRate: 40,
      sessionReplaySampleRate: 20,
      trackUserInteractions: true,
      trackResources: true,
      trackLongTasks: true,
      defaultPrivacyLevel: 'allow'
    });
  }
};

/**
 * Log an error
 */
export const logError = (error: Error, context?: Record<string, any>) => {
  datadogRum.addError(error, context);
};

/**
 * Add custom attributes
 */
export const addAttribute = (key: string, value: any) => {
  datadogRum.setGlobalContextProperty(key, value);
};
